import { EntityUtils } from '@record-it-npm/synchro-client';
import { TimeTrackingActivityCompilation } from './timeTrackingActivityCompilationTypes';

export class TimeTrackingActivityCompilationUtils {
  public static displayTextGetter = (
    compilation: TimeTrackingActivityCompilation
  ): string => compilation.name;
  public static keyGetter = (
    compilation: TimeTrackingActivityCompilation
  ): string => EntityUtils.getTrackingKey(compilation);
}
